import React, { useEffect, useState } from "react";
import api from "../../api/api";

const UserManagement = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);

    const loadUsers = async () => {
        try {
            setLoading(true);
            const res = await api.get("/admin/users");
            setUsers(res.data);
        } catch (err) {
            console.error("Failed to load users", err);
            alert("Error loading users");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadUsers();
    }, []);

    const handleDisable2FA = async (userId) => {
        if (!window.confirm("Disable 2FA for this user?")) return;

        try {
            await api.post(`/admin/users/${userId}/disable-2fa`);
            alert("2FA disabled successfully");
            loadUsers();
        } catch (err) {
            console.error(err);
            alert("Failed to disable 2FA");
        }
    };
    const handleChangeUserType = async (userId, newType) => {
        if (!window.confirm(`Change user type to ${newType}?`)) return;

        try {
            await api.put(`/admin/users/${userId}/change-login-type`, {
                userType: newType
            });

            alert("User type updated");
            await loadUsers();
        } catch (err) {
            console.error(err);
            alert("Failed to change user type");
        }
    };
    return (
        <div>
            <h2>User Management</h2>

            {loading && <p>Loading...</p>}

            <table border="1" cellPadding="8">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Email</th>
                        <th>2FA</th>
                        <th>Actions</th>
                        <th>Type</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map(u => (
                        <tr key={u.id}>
                            <td>{u.id}</td>
                            <td>{u.email}</td>
                            <td>
                                {u.isTwoFactorEnabled
                                    ? "Enabled"
                                    : "Disabled"}
                            </td>
                            <td>
                                {u.isTwoFactorEnabled && (
                                    <button
                                        onClick={() =>
                                            handleDisable2FA(u.id)
                                        }
                                    >
                                        Disable 2FA
                                    </button>
                                )}
                            </td>
                            <td>
                                <select
                                    value={u.userType ?? "Individual"}
                                    onChange={(e) =>
                                        handleChangeUserType(u.id, e.target.value)
                                    }
                                >
                                    <option value="Individual">Individual</option>
                                    <option value="LegalEntity">LegalEntity</option>
                                    <option value="Admin">Admin</option>
                                </select>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default UserManagement;
